<mvdnow-view-detail *ngIf="viewService.showDetailView"></mvdnow-view-detail>
<title-view *ngIf="viewService.showTitleView"></title-view>